import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  r: "5",
  cx: "10",
  cy: "10",
  "stroke-width": "4",
  stroke: "hsl(0 0% 80% / 0.5)",
  fill: "none"
}, null, -1)
const _hoisted_3 = ["stroke-dasharray"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 20 20",
    width: _ctx.size,
    height: _ctx.size
  }, [
    _hoisted_2,
    _createElementVNode("circle", {
      r: "5",
      cx: "10",
      cy: "10",
      "stroke-width": "3",
      stroke: "#57c7c2",
      fill: "none",
      "stroke-dasharray": ((2 * 3.14 * 5) * (_ctx.count / _ctx.max)) + ' 50',
      transform: "rotate(-90)",
      "transform-origin": "center"
    }, null, 8, _hoisted_3)
  ], 8, _hoisted_1))
}